export const topNavBarHeight = '64px';
export const leftBarWidth = 72;
export const leftBarSeperatorColor = 'rgba(0, 0, 0, 0.12)';
